import {
  required as requiredValidation,
  sameAs as sameAsValidation,
} from 'vuelidate/lib/validators'

// default export mixin base layer for validation which can be used as mixin.
export default {
  data() {
    return {
      loading: null,
    }
  },
  mounted() {
    this.$store.dispatch('setFormError', null)
  },
  validations: {
    agree: {
      sameAsValidation: sameAsValidation(() => true),
    },
    agree2: {
      sameAsValidation: sameAsValidation(() => true),
    },
    trsCustomerInput: {
      requiredValidation,
    },
  },
  methods: {
    formErrorHandling(error) {
      this.loading = false
      this.$store.dispatch('setFormError', error)
    },
  },
}
